import { React, useEffect, useRef, useState } from "react";
import QRCode from "react-qr-code";
import AppButton from "../../../../base/AppButton.component";
import {
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import { useAuth } from "../../../../../context/Auth.context";
import { appUrl, capitalizeFirstLetter } from "../../../../../utils/Utils";
import { Box } from "@mui/system";
import { Link, ContentCopy, QrCode } from "@mui/icons-material";
import { QRPageStyle } from "../../../../../utils/Styles.utils";
import QRCodeUtils from "../../../../../utils/qrcode";
import { useParams } from "react-router-dom";
// import { EncryptData } from "../../../../../utils/dataEncryptDecrypt";

const QRCodeDialog = () => {
  const auth = useAuth();
  const params = useParams();
  const printRef = useRef();
  let handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: QRPageStyle,
  });

  const getWorkFlowDetails = auth?.user?.associateDetails?.filter((data) => {
    return data?.dealership_id === auth?.user?.dealership_id;
  });
  console.log("getWorkFlowDetails", getWorkFlowDetails);

  // const encryptedData = EncryptData({
  //   dealershipId: auth.user.dealership_id || params.dealershipId,
  //   spid: auth?.user?.user_id,
  //   customer: getWorkFlowDetails[0]?.verification_workflow_id,
  // });
  // console.log("encryptedData", encryptedData);
  // let url = `${appUrl}/getUserDetails/${encryptedData}`;
  let url = `${appUrl}/getUserDetails/${auth.user.user_id}/${auth.user.dealership_id}/${getWorkFlowDetails[0]?.verification_workflow_id}`;
  console.log("auth", auth?.user?.dealership_logo);

  return (
    <>
      <Divider />
      <Paper
        sx={{
          background: "white",
          padding: "16px",
          display: { xs: "contents", sm: "flex" },
          justifyContent: "center",
          boxShadow: "none",
          flexDirection: "column",
        }}
      >
        <Box
          ref={printRef}
          sx={{
            background: "white",
            padding: "16px",
            display: { xs: "contents", sm: "flex" },
            justifyContent: "center",
            boxShadow: "none",
            flexDirection: "column",
            overflowX: window.innerWidth <= 750 ? "scroll" : null,
            // alignItems: "center",
            boxShadow:
              "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              // ml: -2,
            }}
          >
            <Box mt={window.innerWidth <= 750 ? 1 : 0}>
              <img
                src={auth.user.dealership_logo}
                width={70}
                height={56.74}
                alt="logo"
                style={{ objectFit: "contain" }}
              />
            </Box>
            <Typography variant="h6" fontFamily={"sans-serif"} ml={5}>
              {capitalizeFirstLetter(auth.user.first_name) +
                " " +
                capitalizeFirstLetter(auth.user.last_name)}{" "}
              Verification
              {/* <br /> */}
              {/* eVerification */}
            </Typography>
          </Box>
          <Divider />
          <Box
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"space-between"}
          >
            <Box mt={1}>
              <Typography variant="h7" fontWeight={"bold"}>
                Why DeliveryIQ+ ?
              </Typography>
              <Box mt={-2}>
                {" "}
                <ol
                  style={{
                    listStyleType: "disc",
                    marginLeft: "2px",
                    // fontSize: "13px",
                  }}
                >
                  <li>The lender requires verification</li>
                  <li>The state requires verification</li>
                  <li>We want to protect your interests</li>
                  <li>We want to save you 15 minutes</li>
                </ol>
              </Box>
            </Box>
            {/* <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"}> */}
            <Box
              display={"flex"}
              flexDirection={window.innerWidth <= 750 ? "column" : "row"}
              justifyContent={"space-between"}
              mt={-3}
            >
              <Box mt={2}>
                {" "}
                <Typography variant="h7" fontWeight={"bold"}>
                  How to DeliveryIQ+ ?
                </Typography>
                <Box mt={-2}>
                  <ol
                    style={{
                      listStyleType: "disc",
                      marginLeft: "2px",
                      // fontSize: "13px",
                    }}
                  >
                    <li>Scan the QR code</li>
                    <li>Enter your information</li>
                    <li>Watch the magic happen</li>
                  </ol>
                </Box>
              </Box>

              <Box
                sx={{
                  // p: 2,
                  display: "flex",
                  justifyContent: "center",
                  // border: "1px solid #e7e7e7",
                  borderRadius: "6px",
                  // boxShadow:
                  //   "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
                  alignItems: "center",
                  mr: 5,
                }}
              >
                <QRCode value={url} size={170} />
              </Box>
            </Box>
          </Box>
        </Box>
        <Typography
          variant="body2"
          sx={{
            display: "flex",
            alignItems: "center",

            padding: "0 2rem",
            mt: "16px",
            justifyContent: "center",
          }}
        >
          ~ or copy the url below manually ~
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "12px",
            marginTop: 2,
            width: "80%",
            alignItems: "center",
            justifyContent: "center",
            ml: "50px",
          }}
        >
          <OutlinedInput
            disabled="true"
            fullWidth
            size="small"
            value={url}
            sx={{
              borderRadius: "6px",
              alignItems: "center",
              justifyContent: "center",
            }}
            startAdornment={
              <InputAdornment position="start">
                <Link edge="start"></Link>
              </InputAdornment>
            }
          />
          <Box
            sx={{
              border: "1px solid #b7b7b7",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              borderRadius: "6px",
              paddingX: "4px",
            }}
          >
            <Tooltip title="Copy" placement="top">
              <IconButton onClick={() => navigator.clipboard.writeText(url)}>
                <ContentCopy />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>
      <Divider sx={{ mt: window.innerWidth <= 750 ? 1 : 0 }} />
      <AppButton
        buttonText="Print QR"
        clickHandler={() => {
          handlePrint();
        }}
        size="medium"
        variant="contained"
        sx={{
          flex: 1,
          mx: "auto",
          width: "50%",
          my: 1,
          marginTop: "16px",
          height: "100%",
        }}
      />

      <Box displayPrint={"block"} display={"none"} ref={printRef}>
        <QRCodeUtils />
      </Box>
    </>
  );
};

export default QRCodeDialog;
